import { useStaticQuery, graphql } from "gatsby";

const AllRecipesQuery = () => {
  const allRecipeData = useStaticQuery(graphql`
    query AllRecipesDataQuery {
      allSanityRecipe {
        nodes {
          _id
          id
          info {
            title
            slug {
              current
            }
            featuredMedia {
              image {
                asset {
                  gatsbyImageData(
                    formats: AUTO
                    width: 500
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
            newProduct
            featuredBadge {
              ...sanityAllergenOrProductBadge
            }
            featuredAllergen {
              ...sanityAllergenOrProductBadge
            }
          }
        }
      }
    }
  `);

  return allRecipeData;
};

export default AllRecipesQuery;
